import Personalizer from 'personalizer';

var ValueSelector = {
    count: 'count',
    avg: 'avg',
    max: 'max',
    min: 'min',
    sum: 'sum'
};

export default {
    ACTIVITY_ACTIVE_CALORIES: {
        id: 1,
        name: 'calories',
        valueSelector: ValueSelector.sum
    },
    ACTIVITY_AVERAGE_BIKE_CADENCE: {
        id: 2,
        name: 'avgBikeCadence'
    },
    ACTIVITY_AVERAGE_HEART_RATE: {
        id: 3,
        name: 'avgHr'
    },
    ACTIVITY_AVERAGE_PACE: {
        id: 4,
        name: 'avgSpeed',
        valueSelector: ValueSelector.sum
    },
    ACTIVITY_AVERAGE_POWER: {
        id: 5,
        name: 'avgPower'
    },
    ACTIVITY_AVERAGE_RUN_CADENCE: {
        id: 6,
        name: 'avgRunCadence'
    },
    ACTIVITY_AVERAGE_SPEED: {
        id: 7,
        name: 'avgSpeed',
        converter: Personalizer.convertCmPerMSToMps
    },
    ACTIVITY_AVERAGE_STROKES: {
        id: 8,
        name: 'avgStrokes'
    },
    ACTIVITY_AVERAGE_SWOLF: {
        id: 9,
        name: 'avgSwolf'
    },
    ACTIVITY_GROUND_CONTACT_TIME: {
        id: 10,
        name: 'avgGroundContactTime'
    },
    ACTIVITY_INTENSITY_FACTOR: {
        id: 11,
        name: 'intensityFactor'
    },
    ACTIVITY_MAX_20_MIN_AVERAGE_POWER: {
        id: 12,
        name: 'max20MinPower',
        valueSelector: ValueSelector.max
    },
    ACTIVITY_MAX_HEART_RATE: {
        id: 13,
        name: 'maxHr',
        valueSelector: ValueSelector.max
    },
    ACTIVITY_MINIMUM_SWOLF: {
        id: 14,
        name: '', // FE will not display minSwolf report
        valueSelector: ValueSelector.min
    },
    ACTIVITY_NORMALIZED_POWER: {
        id: 15,
        name: 'normPower'
    },
    ACTIVITY_NUMBER_OF_ACTIVITIES: {
        id: 16,
        name: 'duration',
        valueSelector: ValueSelector.count
    },
    ACTIVITY_TOTAL_DISTANCE: {
        id: 17,
        name: 'distance',
        converter: Personalizer.convertCmToM,
        valueSelector: ValueSelector.sum
    },
    ACTIVITY_TOTAL_DURATION: {
        id: 18,
        name: 'duration',
        converter: Personalizer.convertMsToSeconds,
        valueSelector: ValueSelector.sum,
        additionalValueSelector: ValueSelector.count,
        additionalLabelKey: 'activities_widget_activities_title'
    },
    ACTIVITY_TRAINING_STRESS_SCORE: {
        id: 19,
        name: 'trainingStressScore'
    },
    ACTIVITY_VERTICAL_OSCILLATION: {
        id: 20,
        name: 'avgVerticalOscillation'
    },
    ACTIVITY_VO2_MAX: {
        id: 21,
        name: 'vO2MaxValue',
        valueSelector: ValueSelector.max
    },
    WELLNESS_ACTIVE_CALORIES: {
        id: 22,
        name: ''
    },
    WELLNESS_BMR_CALORIES: {
        id: 23,
        name: ''
    },
    FOOD_CALORIES_CONSUMED: {
        id: 24,
        name: ''
    },
    FOOD_CALORIES_REMAINING: {
        id: 25,
        name: ''
    },
    SLEEP_SLEEP_DURATION: {
        id: 26,
        name: ''
    },
    SLEEP_SLEEP_MOOD: {
        id: 27,
        name: ''
    },
    WELLNESS_TOTAL_CALORIES: {
        id: 28,
        name: ''
    },
    WELLNESS_TOTAL_STEPS: {
        id: 29,
        name: ''
    },
    ACTIVITY_AVERAGE_EFFICIENCY: {
        id: 30,
        name: ''
    },
    ACTIVITY_LEFT_BALANCE: {
        id: 31,
        name: 'avgLeftBalance'
    },
    ACTIVITY_MINIMUM_EFFICIENCY: {
        id: 32,
        name: ''
    },
    ACTIVITY_MINIMUM_STROKES: {
        id: 33,
        name: 'minStrokes',
        valueSelector: ValueSelector.min
    },
    ACTIVITY_RIGHT_BALANCE: {
        id: 34,
        name: 'avgRightBalance'
    },
    ACTIVITY_TOTAL_ELEVATION_GAIN: {
        id: 35,
        name: 'elevationGain',
        converter: Personalizer.convertCmToM,
        valueSelector: ValueSelector.sum
    },
    ACTIVITY_TOTAL_ELEVATION_LOSS: {
        id: 36,
        name: 'elevationLoss',
        converter: Personalizer.convertCmToM,
        valueSelector: ValueSelector.sum
    },
    ACTIVITY_TOTAL_SWIMMING_STROKES: {
        id: 37,
        name: ''
    },
    WELLNESS_TOTAL_STEP_GOAL: {
        id: 38,
        name: ''
    },
    WELLNESS_TOTAL_DISTANCE: {
        id: 39,
        name: ''
    },
    WELLNESS_AVERAGE_STEPS: {
        id: 40,
        name: ''
    },
    COMMON_TOTAL_CALORIES: {
        id: 41,
        name: ''
    },
    COMMON_ACTIVE_CALORIES: {
        id: 42,
        name: ''
    },
    COMMON_TOTAL_DISTANCE: {
        id: 43,
        name: ''
    },
    ACTIVITY_VO2_MAX_CYCLING: {
        id: 44,
        name: 'vO2MaxValue',
        valueSelector: ValueSelector.max
    },
    ACTIVITY_AVG_STRIDE_LENGTH: {
        id: 45,
        name: 'avgStrideLength',
        converter: Personalizer.convertCmToM
    },
    ACTIVITY_AVG_VERTICAL_RATIO: {
        id: 46,
        name: 'avgVerticalRatio'
    },
    ACTIVITY_AVG_GROUND_CONTACT_BALANCE: {
        id: 47,
        name: 'avgGroundContactBalance'
    },
    ACTIVITY_AVG_LACTATE_THRESHOLD_BPM: {
        id: 48,
        name: 'lactateThresholdBpm'
    },
    ACTIVITY_AVG_LT_SPEED_MTR_PER_SEC: {
        id: 49,
        name: 'lactateThresholdSpeed'
    },
    ACTIVITY_MAX_FTP: {
        id: 50,
        name: 'maxFtp',
        valueSelector: ValueSelector.max
    },
    WELLNESS_MODERATE_INTENSITY_MINUTES: {
        id: 51,
        name: ''
    },
    WELLNESS_VIGOROUS_INTENSITY_MINUTES: {
        id: 52,
        name: ''
    },
    WELLNESS_FLOORS_ASCENDED: {
        id: 53,
        name: ''
    },
    WELLNESS_FLOORS_DESCENDED: {
        id: 54,
        name: ''
    },
    WELLNESS_USER_INTENSITY_MINUTES_GOAL: {
        id: 55,
        name: ''
    },
    WELLNESS_USER_FLOORS_ASCENDED_GOAL: {
        id: 56,
        name: ''
    },
    WELLNESS_MIN_HEART_RATE: {
        id: 57,
        name: ''
    },
    WELLNESS_MAX_HEART_RATE: {
        id: 58,
        name: ''
    },
    ACTIVITY_AVERAGE_SWIM_PACE: {
        id: 59,
        name: 'avgSpeed',
        converter: Personalizer.convertCmPerMSToMps
    },
    WELLNESS_RESTING_HEART_RATE: {
        id: 60,
        name: ''
    },
    ACTIVITY_AEROBIC_TRAINING_EFFECT: {
        id: 61,
        name: 'aerobicTrainingEffect'
    },
    ACTIVITY_ANAEROBIC_TRAINING_EFFECT: {
        id: 62,
        name: 'anaerobicTrainingEffect'
    },
    WELLNESS_AVERAGE_STRESS: {
        id: 63,
        name: ''
    },
    WELLNESS_HIGH_STRESS: {
        id: 64,
        name: ''
    },
    ACTIVITY_HRV_STRESS_TEST: {
        id: 65,
        name: ''
    },
    WELLNESS_BODYBATTERY_CHARGED: {
        id: 84,
        name: ''
    },
    WELLNESS_BODYBATTERY_DRAINED: {
        id: 85,
        name: ''
    },

    // metrics below here aren't supported by the API, they have negative ids
    ACTIVITY_TRAINING_STATUS: {
        id: -1,
        name: ''
    },
    STRENGTH_TRAINING: {
        id: -2,
        name: ''
    },
    Activity_Id: {
        id: -3,
        name: 'activityId'
    },
    ACTIVITY_AEROBIC_TRAINING_EFFECT_CYCLING: {
        id: -4,
        name: ''
    },
    ACTIVITY_ANAEROBIC_TRAINING_EFFECT_CYCLING: {
        id: -5,
        name: ''
    },
    ACTIVITY_POWER_CURVE_CYCLING: {
        id: -6,
        name: 'maxAvgPower_1'
    },
    OUTDOOR_PULSE_OX_ACCLIMATION: {
        id: -7,
        name: ''
    },
    WELLNESS_HYDRATION: {
        id: -8,
        name: ''
    },
    ACTIVITY_TRAINING_STATUS_CYCLING: {
        id: -9,
        name: ''
    },
    PILATES: {
        id: -10,
        name: ''
    },
    TRAINING_EFFECT_LABEL: {
        id: -11,
        name: 'trainingEffectLabel'
    },
    ACTIVITY_TRAINING_LOAD: {
        id: -12,
        name: 'activityTrainingLoad'
    },
    START_LOCAL: {
        id: -13,
        name: 'startLocal'
    },
    ACTIVITY_TYPE: {
        id: -14,
        name: 'activityType'
    },
    ACTIVITY_SUB_TYPE: {
        id: -15,
        name: 'activitySubType'
    },
    MENSTRUAL_CYCLE_TRACKING_REPORTS: {
        id: -16,
        name: 'menstrualCycleTracking'
    },
    ACTIVITY_NAME: {
        id: -17,
        name: 'name'
    },
    ALL_DAY_PULSE_OX: {
        id: -18,
        name: ''
    },
    ALL_DAY_RESPIRATION: {
        id: -19,
        name: ''
    },
    ACTIVITY_AVERAGE_RESPIRATION_RATE: {
        id: -20,
        name: 'avgRespirationRate'
    },
    ACTIVITY_TOTAL_DURATION_WITH_FILTERING: {
        id: -21,
        name: 'duration'
    },
    ACTIVITY_PARENT_ID: {
        id: -22,
        name: 'parentId'
    },
    REPORTS_AVERAGE_SWIM_PACE: {
        id: -23,
        name: 'avgSpeed',
        converter: Personalizer.convertCmPerMSToMps
    },
    REPORTS_AVERAGE_CYCLING_PACE: {
        id: -24,
        name: 'avgSpeed'
    },
    REPORTS_AVERAGE_RUNNING_PACE: {
        id: -25,
        name: 'avgSpeed'
    },
    SLEEP_SLEEP_SCORE: {
        id: -26,
        name: ''
    },
    PREGNANCY_TRACKING_REPORTS: {
        id: -27,
        name: 'pregnancyTracking'
    },
    FITNESS_AGE: {
        id: -28,
        name: 'fitnessAge'
    },
    ACTIVITY_RACE_PREDICTOR_TRENDS: {
        id: -29,
        name: ''
    },
    TRAINING_EFFECT_LABEL_SERVER_CALC: {
        id: -30,
        name: 'trainingEffectLabelSrvrCalc'
    },
    ACTIVITY_TRAINING_LOAD_SERVER_CALC: {
        id: -31,
        name: 'activityTrainingLoadSrvrCalc'
    },
    REPORTS_AVERAGE_CYCLING_SPEED: {
        id: -32,
        name: 'avgSpeed',
        converter: Personalizer.convertCmPerMSToMps
    },
    REPORTS_AVERAGE_RUNNING_SPEED: {
        id: -33,
        name: 'avgSpeed',
        converter: Personalizer.convertCmPerMSToMps
    },
    ACTIVITY_HRV_STATUS: {
        id: -34,
        name: 'hrvStatus'
    },
    FTP_CYCLING: {
        id: -35,
        name: 'cyclingFtp',
        valueSelector: ValueSelector.max
    },
    FTP_XC_SKI: {
        id: -36,
        name: 'xcSkiFtp',
        valueSelector: ValueSelector.max
    },
    CRITICAL_SWIM_SPEED: {
        id: -37,
        name: 'criticalSwimSpeed'
    },
    ACTIVITY_AVERAGE_WHEELCHAIR_PUSH_CADENCE: {
        id: -38,
        name: 'avgWheelchairCadence',
        chartType: 'SCATTERED_WITH_AVG'
    },
    REPORTS_RUNNING_LACTATE_THRESHOLD: {
        id: -39,
        name: 'runningLactateThreshold'
    },
    HILL_SCORE: {
        id: -40,
        name: 'hillScore'
    },
    ENDURANCE_SCORE: {
        id: -41,
        name: 'enduranceScore'
    },
    GAMING_WIN_RATE: {
        id: -42,
        name: ''
    },
    GAMING_STRESS: {
        id: -43,
        name: ''
    },
    GAMING_BODY_BATTERY: {
        id: -44,
        name: ''
    },
    WELLNESS_TOTAL_PUSHES: {
        id: -45,
        name: 'totalPushes'
    },
    RUNNING_TOLERANCE: {
        id: -46,
        name: 'runningTolerance'
    },
    MOBILITY: {
        id: -47,
        name: 'mobility'
    },
    PACK_WEIGHT: {
        id: -48,
        name: 'beginPackWeight'
    },
    RUNNING_ECONOMY: {
        id: -49,
        name: 'runningEconomy'
    },
    ACTIVITY_AVG_STEP_SPEED_LOSS: {
        id: -50,
        name: 'avgStepSpeedLoss',
        chartType: 'SCATTERED_WITH_AVG'
    },
    ACTIVITY_AVG_STEP_SPEED_LOSS_PERCENT: {
        id: -51,
        name: 'avgStepSpeedLossPercent',
        chartType: 'SCATTERED_WITH_AVG'
    }
};
